import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React from "react";
import PreparationCommon from "../commonForms/preparation";

const Preparation = () => {
  const { currentPreparation } = useAnalysis();

  return (
    <>
      {currentPreparation.index !== undefined && (
        <>
          <PreparationCommon />
        </>
      )}
    </>
  );
};

export default Preparation;
